const SeoTaxonomyFragment = `
fragment SeoTaxonomyFragment on TaxonomySEO {
	canonical
	fullHead
	opengraphTitle
	title
}
`;

export default SeoTaxonomyFragment;
